module.exports = __webpack_public_path__ + "static/media/bats.0bfe75f3.png";